import React, { useContext, useRef } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import _get from 'lodash/get';

import { If } from 'utils';
import { TourGuides } from 'containers';
import Nav from '../Nav';
import QuotaUsage from './QuotaUsage';
import StickyFooter from '../StickyFooter';
import CustomerPortalLink from './CustomerPortalLink';
import { AuthContext } from 'context/AuthContext';
import { admin, store, warehouse } from 'config/nav';
import { useAppContext } from 'utils/hooks';

export default function RetexNav() {
  const { appType, roles, configuration } = useContext(AuthContext);
  const { isSSREnv } = useAppContext();
  const footerRef = useRef();

  const isWarehouse = _get(roles, 'warehouse', false);
  const isStore = _get(roles, 'store', false);
  const isAdmin = _get(roles, 'admin', false);

  if (!appType.retex) return null;

  return (
    <Switch>
      <Route
        path="/w"
        render={() => {
          if (!isWarehouse) return <Redirect to="/" />;
          return <Nav config={warehouse} />;
        }}
      />
      <Route
        path="/s"
        render={() => {
          if (!isStore) return <Redirect to="/" />;
          return <Nav config={store} />;
        }}
      />
      <Route
        path="/"
        render={() => {
          if (!isAdmin) return <Redirect to="/" />;

          const config = admin.getConfig(configuration, isSSREnv);
          return (
            <Nav config={config}>
              <StickyFooter ref={footerRef}>
                <QuotaUsage />
                <CustomerPortalLink />
                <If test={!isSSREnv}>
                  <TourGuides.FeaturesChecklist />
                </If>
              </StickyFooter>
            </Nav>
          );
        }}
      />
    </Switch>
  );
}
